import { Heading } from '@ui/primitives/Heading'
import { Text } from '@ui/primitives/Text'
import { Button } from '@ui/primitives/Button'
import { Icon } from '@ui/primitives/Icon'
import Link from 'next/link'
import { cn } from '@ui/lib/utils'

interface EmptyStateProps {
  icon?: string
  title: string
  description: string
  actionLabel?: string
  actionHref?: string
  className?: string
}

export function EmptyState({
  icon = 'search',
  title,
  description,
  actionLabel,
  actionHref,
  className,
}: EmptyStateProps) {
  return (
    <div className={cn('text-center py-12', className)}>
      <div className="flex justify-center mb-4">
        <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center">
          <Icon name={icon} size="lg" className="text-gray-400" />
        </div>
      </div>
      <Heading as="h2" size="lg" className="mb-2">
        {title}
      </Heading>
      <Text size="md" className="mb-6 max-w-md mx-auto">
        {description}
      </Text>
      {actionLabel && actionHref && (
        <Button asChild size="md">
          <Link href={actionHref}>{actionLabel}</Link>
        </Button>
      )}
    </div>
  )
}
